import addToCart from '../lib/addToCart';
import { SELECTORS } from '../utils/constants';

const initCartUpsellAtc = (onAdded) => {
  const minicartToggle = document.querySelector('[data-minicart-toggle]');
  const cartUpsellEl = document.querySelector('[data-cart-upsell]');
  if (!cartUpsellEl) return;

  let isLoading = false;

  cartUpsellEl.addEventListener('click', async (evt) => {
    const atcBtn = evt.target.closest('[data-cart-upsell-atc]');
    if (!atcBtn || isLoading) return;
    const loadingSpinner = atcBtn.querySelector(SELECTORS.LOADING_SPINNER);
    isLoading = true;

    loadingSpinner?.classList.toggle('hidden', !isLoading);
    atcBtn.classList.toggle('opacity-50', isLoading);
    atcBtn.disabled = isLoading;

    try {
      await addToCart(atcBtn.dataset.cartUpsellAtc, 1);
      if (minicartToggle && typeof onAdded === 'function') {
        onAdded();
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.error('Failed to add to cart:', error);
    } finally {
      isLoading = false;
      loadingSpinner?.classList.toggle('hidden', isLoading);
      atcBtn.classList.toggle('opacity-50', isLoading);
    }
  });
};

export default initCartUpsellAtc;
